module.exports = __webpack_public_path__ + "39a8b55b269a0f6945bce9db0a692f42.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/gears5/exhibit.png
// module id = 1066
// module chunks = 0